import { Component, JSXElement, Show } from "solid-js"

type Props = {
    when: any;
    children: JSXElement;
}
export const Div : Component<any> = (props) => {
    const { when, children, ...others } = props;
    return (
        <Show when={when}>
            <div {...others}>
                {children}
            </div>
        </Show>
    )
}
